$(document).ready(function () {
    'use strict';

    $(window).trigger('scroll');

    const videoTab = $(".js_videoTab");

    if (videoTab.length > 0) {
        videoTab.click(function() {
            $(this).find("h3").toggleClass("active");
            $(this).closest(".videoTab").find(".videoTabDescription").slideToggle();
        });
    }

    const switchTab = $(".js_switchCars li");

    if (switchTab.length > 0) {
        switchTab.click(function() {
            var activeSlider = $(".tabSlider#" + $(this).data("id"));

            switchTab.removeClass("active");
            $(this).addClass("active");

            $(".tabSlider").hide();
            activeSlider.show();

            setTimeout(function() {
                $(".js_franchiseCarSlider").slick("refresh");
            }, 200);

            setTimeout(function() {
                $(window).trigger('scroll');
            }, 500);
        });
    }

    const switchPhotos = $(".js_switchPhotos li");

    if (switchPhotos.length > 0) {
        switchPhotos.click(function() {
            const activeSlider = $(".photoSlider#" + $(this).data("id"));

            switchPhotos.removeClass("active");
            $(this).addClass("active");

            $(".photoSlider").hide();
            activeSlider.show();
            activeSlider.find(".js_photoSlider").slick("refresh");
        });
    }
});
